import React from 'react';
import { Modal } from 'components/elements';
import { Form, Input } from 'antd';

interface JoinGroupModalProps {
    open: boolean;
    loading?: boolean;
    onCancel: () => void;
    onJoin: (values: { groupId: string }) => Promise<void> | void;
}

const JoinGroupModal: React.FC<JoinGroupModalProps> = ({ open, loading = false, onCancel, onJoin }) => {
    const [form] = Form.useForm();

    return (
        <Modal
            title="Join Group"
            open={open}
            onRightText="Join"
            onCancel={onCancel}
            onRight={() => form.submit()}
            onRightProps={{ loading }}
            destroyOnClose={false}
            forceRender
        >
            <Form
                layout="vertical"
                form={form}
                onFinish={async (vals) => {
                    await onJoin(vals as { groupId: string });
                    form.resetFields();
                }}
                validateTrigger="onChange"
            >
                <Form.Item
                    label="Group Name"
                    name="groupName"
                    rules={[{ required: true, message: 'Please input a valid Group Name!' }]}
                >
                    <Input placeholder="Enter group name" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default JoinGroupModal;